import { Transforms } from 'slate';

export const insertList= (editor, type, options) => {
  const list = {
      type: type,
      children: [{
          type: 'li',
          children: [{ type: 'p', children: [{ text: '' }] }],
        }],
  };

  if (editor.selection) {
      Transforms.insertNodes(editor, list, {
          at: [editor.selection.focus.path[0] + 1],
          select: true
      });
  } else {
      Transforms.insertNodes(editor, list, {
          at: [editor.children.length + 1]
      });
  }
  console.log({ selection: editor.selection })
  // console.log({next: Path.next(editor.selection.focus.path)})
 
  Transforms.move(editor);
      // scrollToNode(editor, lastElement);

};